import { CopyAmountToAllBookingItem } from "@/models/api/commands/booking/CopyAmountToAllBookingItem";

export class CopyGrandTotalToAllBookingItem extends CopyAmountToAllBookingItem {
  CommandName = "CopyGrandTotalToAllBookingItem";

  constructor(
    sessionId: string,
    operationId: string,
    grandTotalInCurrency: number,
    currency: string,
    grandTotal: number,
    exchangeDate: string | null,
    exchangeRate: number | null
  ) {
    super(sessionId, operationId, grandTotalInCurrency, currency, grandTotal, exchangeDate, exchangeRate);
  }
}
